export default {

  /* 转换百分数后保留1位小数 */
  "RATE_FIXED_NUM" : 1,

  /* 分数保留1位小数 */
  "SCORE_FIXED_NUM" : 1,

  /**
   * 时间过滤条件起始查询时间, 默认从2015年开始到当前学年
   * */
  "START_YEAR": 2016,

  /**
   * 默认阳历9月1日开学, 到次年农历正月初一算第一学期, 到次年8月31日算第二学期
   * */
  "TERM_START_DATE": "08-15",

  "TERM_END_DATE": "08-14",

  "TERM_SPLIT_MONTH": 1, //农历正月

  "TERM_SPLIT_DATE": 1,   //农历初一

  "MIN_RANK_VALUE": 3,    //排名最少有3个刻度

  /**
   * ======================================================
   * 分割线, 以下写枚举类型
   * ======================================================
   * */

  //用户类型：1.学生2.教师7.市教研员8.区教研员9.校教研员10.资源组账号
  "USER_TYPE": {
    "student":"1",
    "teacher":"2",
    "city":"7",
    "area":"8",
    'school':"9",
    'resource':"10",
    'admin':"5"
  },


  /**
   * ======================================================
   * 分割线, 以下是图表统一颜色配置
   * ======================================================
   * */

  "ECHARTS_COLOR" : [
  //'#2ec7c9',
  '#50b4fa','#69d9b0','#f57f71','#ff475a',
    '#e5bc65','#4ed5c5','#f97286','#d87a80',
  '#8d98b3','#e5cf0d','#97b552','#95706d','#dc69aa',
  '#07a2a4','#9a7fd1','#588dd5','#f5994e','#c05050',
  '#59678c','#c9ab00','#7eb00a','#6f5553','#c14089'
  ],
/* 升序 */
"SORT_ASC" : 1,
  /* 降序 */
  "SORT_DESC" : 2
  ,
  /**
   * ======================================================
   * 分割线, 以下是考试分析报告中区间段步长设置
   * 饼状图
   * 柱状图
   * ======================================================
   * */
  "PIE_STEP":5,
  "HISTOGRAM_STEP":10
}



// WEBPACK FOOTER //
// ./src/utils/constants.js